import type { IAdAttributeView } from '../types';

const findAttributeValue = (
  displayAttributes: IAdAttributeView[],
  requiredAttribute: string,
) => {
  return displayAttributes.find(
    (attribute) => attribute.name === requiredAttribute,
  )?.value;
};

export const findAttributeValues = (
  displayAttributes: IAdAttributeView[],
  requiredAttributes: string[],
) => {
  const result: { [key: string]: string | undefined } = {};
  requiredAttributes.forEach((requiredAttribute) => {
    result[requiredAttribute] = findAttributeValue(
      displayAttributes,
      requiredAttribute,
    );
  });
  return result;
};
